// @flow
import type { PromotionType } from '.';

export type ReferralBonusActionType =
  | {|
      type: 'SIGNUP_SET_GODFATHER_EXTERNAL_ID',
      payload: { godfatherExternalId: ?string },
    |}
  | {|
      type: 'SIGNUP_VERIFY_GODFATHER',
      payload: { godfatherExternalId: ?string },
    |}
  | {|
      type: 'SIGNUP_SET_GODFATHER_VALIDITY',
      payload: { isValid: boolean, error: ?string },
    |};

export type ActivationBonusActionType =
  | {|
      type: 'SIGNUP_SET_ACTIVATION_BONUS_VALIDITY',
      payload: { isActivationBonusValid: boolean },
    |}
  | {|
      type: 'SIGNUP_SET_ACTIVATION_NOT_FIRST_LINE',
      payload: { isNotFirstSubscription: boolean },
    |}
  | { type: 'SIGNUP_VERIFY_ACTIVATION_BONUS' };

export type VerifyBonusesActionType = {|
  type: 'VERIFY_BONUSES',
|};

export type PromotionCodeActionType =
  | {|
      type: 'SIGNUP_VERIFY_PROMOTION_CODE',
      payload: { promotionCode: string },
    |}
  | {|
      type: 'SIGNUP_SET_PROMOTION_MODAL_VISIBLE',
      payload: { isModalVisible: ?boolean },
    |}
  | {|
      type: 'SIGNUP_SET_PROMOTION',
      payload: { promotion: ?PromotionType },
    |};

export const setGodfatherExternalId = (godfatherExternalId: ?string): ReferralBonusActionType => ({
  type: 'SIGNUP_SET_GODFATHER_EXTERNAL_ID',
  payload: { godfatherExternalId },
});

export const verifyGodfather = (godfatherExternalId: ?string): ReferralBonusActionType => ({
  type: 'SIGNUP_VERIFY_GODFATHER',
  payload: { godfatherExternalId },
});

export const verifyBonuses = (): VerifyBonusesActionType => ({
  type: 'VERIFY_BONUSES',
});

export const verifyPromotionCode = (promotionCode: string): PromotionCodeActionType => ({
  type: 'SIGNUP_VERIFY_PROMOTION_CODE',
  payload: { promotionCode },
});

export const setGodfatherValidity = (isValid: boolean, error?: ?string = null): ReferralBonusActionType => ({
  type: 'SIGNUP_SET_GODFATHER_VALIDITY',
  payload: { isValid, error },
});

export const verifyActivationBonus = (): ActivationBonusActionType => ({
  type: 'SIGNUP_VERIFY_ACTIVATION_BONUS',
});

export const setActivationBonusValidity = (isActivationBonusValid: boolean): ActivationBonusActionType => ({
  type: 'SIGNUP_SET_ACTIVATION_BONUS_VALIDITY',
  payload: { isActivationBonusValid },
});

export const setActivationNotFirstSubscription = (isNotFirstSubscription: boolean): ActivationBonusActionType => ({
  type: 'SIGNUP_SET_ACTIVATION_NOT_FIRST_LINE',
  payload: { isNotFirstSubscription },
});

export const setPromotionCodeModalVisible = (isModalVisible: boolean): PromotionCodeActionType => ({
  type: 'SIGNUP_SET_PROMOTION_MODAL_VISIBLE',
  payload: { isModalVisible },
});

export const setPromotion = (promotion: ?PromotionType): PromotionCodeActionType => ({
  type: 'SIGNUP_SET_PROMOTION',
  payload: { promotion },
});
